module.exports = __webpack_public_path__ + "static/media/bikesha_bugesera5.648adb29.jpeg";